module.exports = __webpack_public_path__ + "static/media/cap1.62cf37e7.png";